import React from 'react'
import { URL_SRV_ARIZTIA } from '../../router/Url';

export const SaveDataTAbleFaena = ({bulkData,PLANTA,USUARIO,AREA}) => {
    // console.log(bulkData);
    return new Promise(async (resolve, reject) => {
        let query = await fetch(URL_SRV_ARIZTIA+'guardaindicadoresdetablafaena',{
          method: 'POST',
          headers: {
            'authorization': "paico2021",
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            TABLA:bulkData,PLANTA,USUARIO,AREA,TIMESTAMP:new Date().getTime()
          })
        })
        let responsito = await query.json();
        // console.log(responsito.body)
        if(responsito.success){
          resolve(responsito.success)
        }else{
          resolve([])
        }
    })
}
